import styled from 'styled-components'

export const AppContentWithNavbar = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  overflow: auto;
`

export const StyledAppContainer = styled.div`
  display: flex;
  height: 100vh;
  background: ${({ theme }) => theme.color.background.main};
`
